import React from 'react'
import './old-timesheet.css'

const OldTimesheet = (props) => {

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const calculateEstimatedPay = (families) => {
        //let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < families.length; i++) {
            let fam = families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        return ((minutesTaught/60) * Number(props.oldTimesheet.teacherRate)) + allExtras
    }

    return(
        <div className="old-timesheet__wrapper">
            <div className="old-timesheet__contents">
                <div className="student-modal-x-wrapper">
                    <div id="student-modal-the-x" onClick={() => props.setOldTimesheet(false)} className="student-modal-the-x">x</div>
                </div>
                <div className="old-timesheet__header">Timesheet</div>
                <div className="old-timesheet__details">{props.teacher.Name}</div>
                <div className="old-timesheet__details">Timesheet ID: {props.oldTimesheet.timesheetId}</div>
                <div className="old-timesheet__details">Timesheet for: {props.oldTimesheet.monthYear}</div>
                <div className="old-timesheet__details">Status: {capitalizeFirstLetter(props.oldTimesheet.status)}</div>
                {props.oldTimesheet.families.map((family) => 
                    <div className="old-timesheet__family-card" key={family.id}>
                        <div className="old-timesheet__family-card--family-name">{family.familyName}:</div>
                        {family.lessons.map((lesson) => 
                            <div className="old-timesheet__family-card--family-name--each-lesson" key={lesson.id}>{lesson.studentName}: {props.oldTimesheet.monthNumber}/{lesson.date} | {lesson.lessonLength}min</div>
                        )}
                    </div>
                )}
                <div>Estimated Pay: ${calculateEstimatedPay(props.oldTimesheet.families)}</div>
            </div>
        </div>
    )
}
export default OldTimesheet